<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon class="bright" points="1,6 6,10 6,7 11,7 11,5 6,5 6,2" />
</svg>
</template>